import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import {
  ReportHeading,
  LoaderWrapper,
  VerbatimImageVideoGrid,
  ReportOuterWrapper,
  Modal,
  MuiButton,
  Loader,
} from '../../../../components'
import ReportsService from '../../../../services/reports.service'
import { useUpdateLhs, useReactQuery, useConditionalQuery } from '../../../../hooks'
import { LEGEND_COLOR_MAP } from '../../../../constants'
import { close, IconCompare, IconProgression } from '../../../../assets/images/icons'
import { getObjectAsArray } from '../../../../util'

import {
  Wrapper,
  GraphDescription,
  GraphLegendWrapper,
  GraphLegend,
  MenuContent,
  MenuClose,
  ModalWrapper,
  TopAuraWrapper,
  AuraModalWrapper,
  AuraMainModal,
} from './style'
import Aura from './aura'
import { useGlobalStore } from '../../../../store'
import projectsService from '../../../../services/projects.service'

const ReportAura = (props) => {
  const [auraData, setAuraData] = useState([])
  const [auraEntityData, setAuraEntityData] = useState({})
  const [auraDetailData, setAuraDetailData] = useState([])
  const [auraExcelData, setAuraExcelData] = useState([])
  const [auraProgressionData, setAuraProgressionData] = useState([]);
  const [auraComparisonData, setAuraComparisonData] = useState([]);
  const [auraTitle, setAuraTitle] = useState(null)
  const [auraTitleColor, setAuraTitleColor] = useState(null)
  const { updateSubLhsApiLoaded } = useUpdateLhs()
  const [eventCount, setEventCount] = useState(1)
  const [showModal, setShowModal] = useState(false);
  const [showCompareAura, setShowCompareAura] = useState(false);
  const [compareAuraData, setCompareAuraData] = useState('');
  const [compareAuraTitle, setCompareAuraTitle] = useState('');
  const [highlightText, setHighlightText] = useState('');
  const [isComparison, setIsComparison] = useState(false);
  const [brandLogoList , setBrandLogoList] = useState([]);
  const isProgressionAura = ['AuraAndProgression', 'AuraWithoutSentimentsAndProgression', 'AuraWithoutSentimentsAndProgressionAndComparison', 'AuraAndProgressionAndComparison'].includes(props.InsightsElementType);
  const isNormalAura = ['AuraWithoutSentiments', 'Aura'].includes(props.InsightsElementType);
  const isComparisonAura = ['AuraAndComparison', 'AuraWithoutSentimentsAndComparison', 'AuraWithoutSentimentsAndProgressionAndComparison', 'AuraAndProgressionAndComparison'].includes(props.InsightsElementType)
  const { resizeWidth, user } = useGlobalStore();
  const [auraType , setAuraType] = useState(isNormalAura);
  const [isLoadingAura , setIsLoadingAura] = useState(false);

  // Get query configurations from api.js

  const useReactQueryObject = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId],
      urlFunc: ReportsService.reportAuraApi,
      payload: { insightsElementId: props.InsightsElementId, entityId: props.EntityId },
    },
    enabled: isNormalAura
  }
  const { data, isLoading, isSuccess, isError, error } = useConditionalQuery(useReactQueryObject, props)

  // Progression Data
  const useReactQueryObject2 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'progression'],
      urlFunc: ReportsService.reportAuraProgressionElement,
      payload: { insightsElementId: props.InsightsElementId, entityId: props.EntityId, periodOrder1Only : true },
    },
    enabled: isProgressionAura
  }
  const { data: data2, isSuccess: isSuccess2, isLoading: isLoading2 } = useConditionalQuery(useReactQueryObject2, props)

  // Comparison Data
  const useReactQueryObject3 = {
    payloadDetails: {
      queryId: [props.InsightsElementType, props.InsightsElementId, 'Comparison'],
      urlFunc: ReportsService.reportAuraComparisonElement,
      payload: { insightsElementId: props.InsightsElementId, entityId: props.EntityId, comparisonBrandOrder1Only : true},
    },
    enabled: isComparisonAura
  }
  const { data: data3, isSuccess: isSuccess3, isLoading: isLoading3 } = useConditionalQuery(useReactQueryObject3, props)

  // Normal Aura
  useEffect(() => {
    if (isSuccess && data && isNormalAura) {
      onSuccessFunc(data)
    }
  }, [isSuccess, data])

  // Progression Aura
  useEffect(() => {
    if (data2 && isSuccess2 && isProgressionAura) {
      const sortedData = data2?.aura?.sort((a, b) => a.PeriodOrder - b.PeriodOrder);
      const data = sortedData.map((e) => ({
        InsightsElementId: e.InsightsElementId,
        ComparisonInsightsElementId: e.PeriodInsightsElementId,
        aura: e.PeriodAuraElements?.AuraElement,
        order: e.PeriodOrder,
        entity: {
          EntityName: e.PeriodName,
          EntityLogo: data2?.entity?.EntityLogo,
        },
        type: 'Progression'
      }));


      setAuraProgressionData(data);

      onSuccessFunc2(data[0])
    };

    if (data3 && isSuccess3 && isComparisonAura) {
      const sortedData = data3?.aura?.sort((a, b) => a.ComparisonBrandOrder - b.ComparisonBrandOrder);
      const data = sortedData.map((e) => ({
        InsightsElementId: e.InsightsElementId,
        ComparisonInsightsElementId: e.ComparisonInsightsElementId,
        aura: e.ComparisonAuraElements?.AuraElement,
        order: e.ComparisonBrandOrder,
        entity: {
          EntityName: e.ComparisonBrandName,
          EntityLogo: data3?.entity?.EntityLogo,
        },
        type: 'Comparison'
      }));

      setAuraComparisonData(data);

      onSuccessFunc2(data[0]);
    }

  }, [data2, isSuccess2 , data3 , isSuccess3])

  // Logo List
  // useEffect(() => {
  //   if (isSuccess4 && data4) {
  //     setBrandLogoList(data4);
  //   }
  // }, [isSuccess4, data4 , auraData])

  // Default Brand Logo
  useEffect(() => {
    if (brandLogoList.length > 0 && auraData?.InsightsElementId && !isNormalAura) { 
      for (let i = 0; i <= brandLogoList?.length; i++) {
        if (brandLogoList[i][auraData.ComparisonInsightsElementId]) {
          setAuraEntityData({ ...auraEntityData, EntityLogo: brandLogoList[i][auraData.ComparisonInsightsElementId].entityId })
          break;
        } else if (brandLogoList[i][auraData.InsightsElementId]){
          setAuraEntityData({ ...auraEntityData, EntityLogo: brandLogoList[i][auraData.InsightsElementId].entityId })
          break;
        }
      }
    }
  }, [brandLogoList , auraData])

  const loadAuraDetail = (data) => {
    setAuraDetailData(data?.VerbatimElement || [])
  }

  const auraClicked = (event, paramArray, compareAura) => {

    if (compareAura) {
      setHighlightText(highlightText === paramArray?.Word ? '' : paramArray?.Word);
    } else {
      const array = {
        ...paramArray,
        Verbatim: { VerbatimElement: getObjectAsArray(paramArray?.Verbatim?.VerbatimElement) },
      }

      if (array.Verbatim.VerbatimElement.length === 0) return
      loadAuraDetail([])
      setAuraTitleColor(array.Sentiment)
      setAuraTitle(array?.Word)
      loadAuraDetail(array?.Verbatim)
      handleOpenUserMenu(event)
    }
  }

  const handleOpenUserMenu = (event) => {
    setShowModal(true);
  }

  const handleCloseUserMenu = () => {
    loadAuraDetail([])
    setShowModal(false);
  }

  const onSuccessFunc = (resp) => {
    let excelData = []

    for (let a = 0; a < resp.aura?.length; a++) {
      excelData.push([{ value: resp.aura[a].Word }, { value: resp.aura[a].Sentiment }])
    }

    setAuraEntityData(resp?.entity)
    // setAuraData(resp.aura)
    setAuraData({
      aura: resp?.aura,
      InsightsElementId: props.InsightsElementId,
      entityName: resp?.entity?.EntityName,
      entityLogo: resp?.entity?.EntityLogo,
    })
    setAuraExcelData(excelData)
    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)
  }

  const onSuccessFunc2 = (resp) => {
    let excelData = []
    for (let a = 0; a < resp.aura?.length; a++) {
      excelData.push([{ value: resp.aura[a].Word }, { value: resp.aura[a].Sentiment }])
    }

    setAuraEntityData(resp?.entity)
    setAuraData(resp)
    setAuraExcelData(excelData)
    updateSubLhsApiLoaded(props)
    setEventCount((p) => p + 1)
  }

  const additionalButtonClicked = (type) => {
    if (type === 'Progression') {
      setCompareAuraTitle(props.Title)
      setIsComparison(false);
      setShowCompareAura(true);

      setIsLoadingAura(true);
      projectsService.reportAuraProgressionElement({ insightsElementId: props.InsightsElementId, entityId: props.EntityId, periodOrder1Only: false })
      .then((resp) => {       
        const sortedData = resp?.aura?.sort((a, b) => a.PeriodOrder - b.PeriodOrder);
        const data = sortedData.map((e) => ({
          InsightsElementId: e.InsightsElementId,
          ComparisonInsightsElementId: e.PeriodInsightsElementId,
          aura: e.PeriodAuraElements?.AuraElement,
          order: e.PeriodOrder,
          entity: {
            EntityName: e.PeriodName,
            EntityLogo: resp?.entity?.EntityLogo,
          },
          type: 'Progression'
        }));

        setAuraProgressionData(data);
        setCompareAuraData(data);
 
        setIsLoadingAura(false);

      })
      .catch((error) => {
        const resMessage = error
        console.log('ERROR : ', resMessage)
        setCompareAuraData(auraProgressionData);
        setIsLoadingAura(false);
        setCompareAuraTitle(props.Title)
        setIsComparison(false);
        setShowCompareAura(true);
      })
    } else {
      setAuraType(false);
      setBrandLogoList([]);
      setAuraEntityData({});
      setCompareAuraTitle(props.Title)
      setIsComparison(true);
      setShowCompareAura(true);

      setIsLoadingAura(true);

      ReportsService.reportAuraComparisonEntityId({ user: user })
      .then((resp) => {

        projectsService.reportAuraComparisonElement({ insightsElementId: props.InsightsElementId, entityId: props.EntityId, comparisonBrandOrder1Only: false })
        .then((resp2) => {
          const sortedData = resp2?.aura?.sort((a, b) => a.ComparisonBrandOrder - b.ComparisonBrandOrder);
          const data = sortedData.map((e) => ({
            InsightsElementId: e.InsightsElementId,
            ComparisonInsightsElementId: e.ComparisonInsightsElementId,
            aura: e.ComparisonAuraElements?.AuraElement,
            order: e.ComparisonBrandOrder,
            entity: {
              EntityName: e.ComparisonBrandName,
              EntityLogo: resp2?.entity?.EntityLogo,
            },
            type: 'Comparison'
          }));

          setAuraEntityData(data?.[0]?.entity || '');

          setAuraComparisonData(data);
          setCompareAuraData(data);

          setBrandLogoList(resp);

          setIsLoadingAura(false);
          setAuraType(true);
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
          setCompareAuraData(data);
          setCompareAuraTitle(props.Title)
          setIsComparison(true);
          setShowCompareAura(true);
          setIsLoadingAura(false); 
        })
  
        })
        .catch((error) => {
          const resMessage = error
          console.log('ERROR : ', resMessage)
          setCompareAuraData(auraComparisonData);
          setCompareAuraTitle(props.Title)
          setIsComparison(true);
          setShowCompareAura(true);
          setIsLoadingAura(false);
        })
    }

  }

  const handleCloseCompareAura = () => {
    setHighlightText('')
    setShowCompareAura(false);
  }

  useEffect(() => {  
   if (isProgressionAura) {
     setAuraType(isSuccess2)
    } else if (isComparisonAura) {
     setAuraType(isSuccess3)
    } else {
     setAuraType(isSuccess)
    }
  } , [isSuccess, isSuccess2, isSuccess3])

  useEffect(() => {
    let element = document.getElementById('reportsContentSection');
  
    if (element) {
      if (isLoadingAura) {
        element.classList.add('componentIsLoading')
      } else {
        element.classList.remove('componentIsLoading'); 
      }
    }
    
  } , [isLoadingAura])

  return (
    <>
      <ReportHeading
        resetInsightHeight={eventCount}
        downloadId={props.type}
        downloadIdData={auraExcelData}
        subHeading=''
        // Put type = props.type currently testing with dummy data
        additionalButton={<AdditionalButtons isNormalAura={isNormalAura} isProgressionAura={isProgressionAura} isComparisonAura={isComparisonAura} btnClicked={additionalButtonClicked} />}
        {...props}
      />
      <ReportOuterWrapper type={props.InsightsElementType}>
        <Wrapper id={props.type}>
          <LoaderWrapper
            loadOnlyApi={props.loadOnlyApi}
            isLoading={isLoading || isLoading2 || isLoading3}
            isSuccess={auraType}
            isError={isError}
            error={error}
          >

            {auraData?.aura?.length > 0 && (
              <Aura minWidth={resizeWidth < 1300 ? 'unset' : '900px'} auraClicked={auraClicked} compareAuraData={auraData} InsightsElementType={props.InsightsElementType} auraEntityData={auraEntityData} {...props} />
            )}

            <AuraLegend InsightsElementType={props.InsightsElementType} padding='9px 0' />

            {showModal &&
              <ModalWrapper>
                <Modal title={auraTitle} titleClass={`modal-title-popup ${auraTitleColor} ${props.InsightsElementType}`} showClose={true} onClose={handleCloseUserMenu} styleType="themeV2">
                  <MenuContent id='menuWrapper'>
                    {/* <MenuClose onClick={handleCloseUserMenu}>
                      <img src={close} alt='close' />
                    </MenuClose> */}
                    {!!auraDetailData?.length && <VerbatimImageVideoGrid data={auraDetailData} maxHeight='525' />}

                    <AuraLegend InsightsElementType={props.InsightsElementType} padding='10px 0 0' />

                  </MenuContent>
                </Modal>
              </ModalWrapper>}


            {showCompareAura &&
              <AuraMainModal className={`${resizeWidth < 1300 ? 'mid-screen' : ''} ${resizeWidth < 1260 ? 'sm-screen' : ''} `}>

                <Modal modalClass='aura-popup' title={compareAuraTitle} showClose={true} onClose={handleCloseCompareAura} styleType="themeV2">
                  <AuraModalWrapper modalheight={window.innerHeight < 850 ? `${window.innerHeight - 84 - 20}` : `${760}`} className='AuraModalWrapper'>
                    <TopAuraWrapper className='TopAuraWrapper'>
                      <Aura {...props} matchText={highlightText} height='377px' minWidth='600px' auraClicked={auraClicked} compareAura={true} compareAuraData={compareAuraData[0]} InsightsElementType={props.InsightsElementType} auraEntityData={auraEntityData} />
                      <Aura {...props} brandLogoList={brandLogoList} auraIndex={1} isComparison={isComparison} matchText={highlightText} height='377px' minWidth='600px' auraClicked={auraClicked} compareAura={true} emptyAura={compareAuraData} InsightsElementType={props.InsightsElementType} auraEntityData={auraEntityData} />
                    </TopAuraWrapper>
                    <Aura {...props} brandLogoList={brandLogoList} auraIndex={2} isComparison={isComparison} matchText={highlightText} height='377px' minWidth='600px' auraClicked={auraClicked} compareAura={true} emptyAura={compareAuraData} InsightsElementType={props.InsightsElementType} auraEntityData={auraEntityData} />
                  </AuraModalWrapper>

                  <AuraLegend InsightsElementType={props.InsightsElementType} padding='5px 0 0' />

                </Modal>
              </AuraMainModal>
            }
          </LoaderWrapper>
        </Wrapper>
      </ReportOuterWrapper>
    </>
  )
}

export default ReportAura

ReportAura.propTypes = {
  InsightsElementType: PropTypes.string,
  InsightsElementId: PropTypes.string,
  EntityId: PropTypes.string,
  loadOnlyApi: PropTypes.bool,
  type: PropTypes.string,
  resetInsightHeight: PropTypes.number,
}

const AuraLegend = (props) => {
  return (
    <GraphDescription className='graphDesc'>
        <GraphLegendWrapper padding={props.padding}>
          <GraphLegend color={LEGEND_COLOR_MAP.Positive}>Positive</GraphLegend>
          <GraphLegend color={LEGEND_COLOR_MAP.Mixed}>Mixed</GraphLegend>
          <GraphLegend color={LEGEND_COLOR_MAP.Negative}>Negative</GraphLegend>
        </GraphLegendWrapper>
    </GraphDescription>
  );
}

const AdditionalButtons = ({ isProgressionAura, isComparisonAura, isNormalAura, btnClicked }) => {
  return (
    <>
      {!isNormalAura && isProgressionAura &&
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={<IconProgression />}
          onClick={() => btnClicked('Progression')}
        >
          Progression
        </MuiButton>
      }

      {!isNormalAura && isComparisonAura &&
        <MuiButton
          variant='outlined'
          color='light'
          startIcon={<IconCompare />}
          onClick={() => btnClicked('Comparison')}
        >
          Compare
        </MuiButton>
      }

    </>
  )
}
